'use strict';
const _ = require('underscore');
module.exports = function RemoteExportController(formatFunctions, configurationGenerator, storageApi, goldFunnelModel, navigatorShim) {
	if (!navigatorShim) {
		throw 'invalid-args';
	}
	const self = this,
		getEventType = function (format) {
			if (!format) {
				return 'Export';
			}
			return format.toUpperCase() + ' Export';
		},
		getExportFunction = function (format) {
			return formatFunctions[format].exporter || formatFunctions[format];
		},
		postProcess = function (format, url, exportProperties) {
			const result = {'output-url': url};
			if (formatFunctions[format].processor) {
				return formatFunctions[format].processor(_.extend(result, exportProperties));
			}
			return Promise.resolve(result);
		},
		workflowError = function (reason, eventType, fileId) {
			if (reason === 'file-too-large') {
				goldFunnelModel.step('layout-export', 'file-too-large');
			}
			if (fileId) {
				return Promise.reject({reason: reason, fileId: fileId});
			} else {
				return Promise.reject(reason);
			}
		},
		waitForResult = function (exportConfig) {
			let shouldInterrupt = false;
			const isStopped = function () {
					return shouldInterrupt;
				},
				pollForError = function (exportConfig) {
					return storageApi.poll(exportConfig.signedErrorListUrl, {stoppedSemaphore: isStopped, timeoutPeriod: 300000, sleepPeriod: 15000}).then(
						function () {
							return Promise.reject('generation-error');
						});
				},
				pollForSuccess = function (exportConfig) {
					return storageApi.poll(exportConfig.signedOutputListUrl, {stoppedSemaphore: isStopped,  timeoutPeriod: 300000, sleepPeriod: 2500});
				};

			return Promise.race([pollForSuccess(exportConfig), pollForError(exportConfig)])
				.then(function () {
					shouldInterrupt = true;
				})
				.catch(function (reason) {
					shouldInterrupt = true;
					throw reason;
				});
		};

	self.startExport = function (format, exportProperties, options) {
		let localExportConfig = false;
		const notifyListeners = function (notification) {
				if (options && options.notify) {
					options.notify(notification);
				}
			},
			eventType = getEventType(format),
			progress = function (progressEvent) {
				notifyListeners('Uploading ' + (progressEvent || ''));
			},
			exportFunc = getExportFunction(format),
			formatContent = function (exported) {
				if (_.isEmpty(exported)) {
					return Promise.reject('empty');
				}
				return JSON.stringify(_.extend({}, exported, exportProperties));
			},
			checkSize = function (formattedContent) {
				if (navigatorShim.binaryStringSize(formattedContent) < localExportConfig.maxSize) {
					return formattedContent;
				}
				if (localExportConfig.free) {
					goldFunnelModel.step('layout-export', 'file-too-large-free');
					throw 'file-too-large-free';
				}
				throw 'file-too-large-gold';
			};

		if (!exportFunc) {
			Promise.reject('no exporter found');
		}
		if (goldFunnelModel) {
			goldFunnelModel.setFunnelId('export-' + format);
		}

		notifyListeners('Setting up the export');

		return configurationGenerator.generateExportConfiguration(format)
			.then(exportConfig => localExportConfig = exportConfig)
			.then(() => exportFunc(exportProperties, localExportConfig))
			.then(formatContent)
			.then(checkSize)
			.then(exportedContent => storageApi.save(exportedContent, localExportConfig, {notify: progress}))
			.then(() => notifyListeners('Processing your export'))
			.then(() => waitForResult(localExportConfig, eventType))
			.then(() => postProcess(format, localExportConfig.signedOutputUrl, exportProperties))
			.catch(reason => workflowError(reason, eventType, localExportConfig && localExportConfig.s3UploadIdentifier));
	};
};

